/**
 * Created by alex.y on 7/31/2017.
 */

import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {RequestOptions} from "@angular/http";
import {BaseResponse} from "../objects/common/baseResponse";
import {Location} from "../objects/management/locationManagement/location";
import {SearchResponse} from "../objects/responses/searchResponse";
import {LocationSearchRequest} from "../objects/requests/locationSearchRequest";
import {LocationUpdateRequest} from "../objects/requests/locationUpdateRequest";
import { OrderLocation } from "../objects/management/order/orderLocation";
import { CountryWithStates } from "../objects/management/locationManagement/countryWithStates";
@Injectable()
export class LocationService extends BaseApi {

    public getAll(top: number, skip: number): Promise<BaseResponse<SearchResponse<Location>>> {
        return this.get(new RequestOptions({
            url: `location/all`,
            params: {
                top: top,
                skip: skip
            }
        }));
    }

    public getById(id: number): Promise<BaseResponse<Location>> {
        return this.get(new RequestOptions({
            url: `currency/${id}`,
        }));
    }

    public modify(updateRequest: LocationUpdateRequest): Promise<BaseResponse<OrderLocation>> {
        return this.put(new RequestOptions({
            url: `location`,
            body: updateRequest
        }))
    }

    public deleteById(id: number): Promise<BaseResponse<boolean>> {
        return this.delete(new RequestOptions({
            url: `location/${id}`,
        }))
    }

    public search(request: LocationSearchRequest): Promise<BaseResponse<SearchResponse<Location>>> {
        return this.post(new RequestOptions({
            url: `location/search`,
            body: request
        }))
    }

    public getCountryStates(): Promise<BaseResponse<CountryWithStates[]>> {
        return this.get(new RequestOptions({
            url: `location/countryStates`
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/locationService.ts